import React, { Component } from 'react';
import { HeadingText, Container, Row, Col } from '@paypalcorp/pp-react';
import styles from './featuredCharityCardContainer.less';
import CharityCard from '../featuredCharityCard/charityCard';
import { ThemeProvider } from '@paypalcorp/pp-react-theme';

export default class CharityCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      charity: {},
    };
  }

  render() {
    let charities = this.props.charities;

    const featuredCharities = charities.map((charity, index) => {
      return (
        <Col
          lg='6'
          md='6'
          key={index}
          sm='12'
          className={styles.featuredCharityCardStyle}
        >
          <CharityCard
            charity={charity}
            gtgEnabled={this.props.gtgEnabled}
            testId={index}
            i18n={this.props.i18n}
            isMobile={this.props.isMobile}
            isTablet={this.props.isTablet}
            enable={this.props.enable}
            campaignState={this.props.campaignInfo.state}
            campaignInfo={this.props.campaignInfo}
            csrf={this.props.csrf}
            fptiInfo={this.props.fptiInfo}
            cdnHost={this.props.cdnHost}
          />
        </Col>
      );
    });
    return (
      <Container
        id='chooseCharities'
        className={styles.featuredCharityCardContainer}
      >
        <HeadingText as='h3' size='md'>
          {this.props.charityModule.header}
        </HeadingText>
        <HeadingText
          as='h3'
          size='sm'
          className={styles.subHeaderStyle}
          dangerouslySetInnerHTML={{
            __html: this.props.charityModule.subHeader,
          }}
        ></HeadingText>
        <Row className={`${styles.featuredCharitiesMargin}`}>
          {featuredCharities}
        </Row>
      </Container>
    );
  }
}
